import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useViewerCanEditSettingsValue } from '../analyticsAdminSettings';
import { useAndReportExperimentTreatment } from '../experiments';
import { useFeatureAccessSettings } from '../featureAccessSettings';

type UseShowAnalyticsSettings = () => boolean;
export const useShowAnalyticsSettings: UseShowAnalyticsSettings = () => {
  const isViewerCanEditSettings = useViewerCanEditSettingsValue();
  const canViewAnswersActivity = useFeatureAccessSettings()?.viewerCanAccessNetworkLevelInsights;

  const isAnalyticsAdminSettingTreatmentEnabled =
    useAndReportExperimentTreatment(Experiment.AnalyticsAdminSetting) === true;
  const isVivaEngagePremium = useAndReportExperimentTreatment(Experiment.VivaEngagePremium) === true;

  return (
    (isAnalyticsAdminSettingTreatmentEnabled || isVivaEngagePremium) &&
    (isViewerCanEditSettings || !!canViewAnswersActivity)
  );
};
